import React from "react";
import { findDOMNode } from "react-dom";
import Classnames from "classnames";
import findIndex from "lodash.findindex";

import loadingIndicator from '../../assets/local-loading.gif';

import "./style.css";

/*
  Props:
  - values: array of values or { value, label } objects
  - selected: value string or { value } object
  - onChange: function taking new selected value as argument
  - type: 'default' (optional), 'list', or 'dropdown'
*/

export default class Radio extends React.PureComponent {
  render() {
    const { selected, values, type, disable } = this.props;
    let onChange = disable ? () => {} : this.props.onChange
    const { deleteCallback } = this.props;

    const { value: selectedValue } = typeof selected !== "object"
      ? { value: selected }
      : selected || {};

    return (
      <div
        className={Classnames("radio-control", type || "default", { disable })}
        tabIndex={-1}
        onKeyDown={event => {
          if (~event.key.indexOf("Arrow")) {
            const direction = ~event.key.indexOf(/Left|Up/) ? -1 : 1;
            const index = findIndex(
              values,
              d => (typeof d !== "object" ? d : d.value) === selectedValue
            );

            let newIndex = index + direction;
            if (newIndex === values.length) newIndex = 0;
            else if (newIndex === -1) newIndex = values.length - 1;

            const newValue = values[newIndex];
            onChange(typeof newValue !== "object" ? newValue : newValue.value);
            event.preventDefault();
          }
        }}
      > 
        <div className="values">
          {values.map((d,i) => {
            const { value, label } = typeof d !== "object"
              ? { value: d, label: d }
              : d || {};
            const selected = selectedValue === value;
            return (
              <div
                key={value}
                className={Classnames("option",{
                  "selected": selected, 
                  "disable": disable,
                  "permanent": d.permanent,
                  "flagFake": d.flagFake,
                })}
                onMouseDown={() => {
                  if(d.flagFake){ return; }
                  const node = findDOMNode(this);
                  if (type === "dropdown" && document.activeElement !== node && !disable){
                    node.focus();
                  } else 
                  if ((type !== "dropdown" || document.activeElement === node) && !disable) {
                    onChange(value);
                    window.setTimeout(() => {
                      node.blur();
                    }, 1);
                  }
                }}
              >
                {type !== "list"
                  ? null
                  : <svg width={14} height={14}>
                      <g transform="translate(7, 7)">
                        <circle r={6} fill="none" strokeWidth={2} />
                        <circle
                          r={3}
                          style={{ fillOpacity: +selected }}
                          strokeWidth={0}
                        />
                      </g>
                    </svg>}
                {type === "dropdown" && !d.permanent && deleteCallback
                  ? [
                      (d.pending 
                        ? <img 
                            className="pending"
                            key="0" 
                            src={loadingIndicator} 
                            alt="Pending" />
                        : <span
                            key="1" 
                            onMouseDown={event => {
                              event.stopPropagation()
                              deleteCallback(i)
                            }}
                            className="delete">
                            {String.fromCharCode(0x00D7)}
                          </span>)
                    ]
                  : null}
                {label}
              </div>
            );
          })}
        </div>

        {type !== "dropdown"
          ? null
          : <svg width={13} height={6}><path d="M 0 0 H 13 L 6.5 6 Z" /></svg>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Radio/index.js